import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class CityHallSystemPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  vendorId?: string;
  user?: string;

  constructor(
    options?: Partial<CityHallSystemPaymentProcessorAccountConfiguration>
  ) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}
